import {filter} from 'rxjs/operators';
import {wsOpened$} from '@/ws';
import {uiMsg$} from '@/ui';
import {DataService} from './DataService';
import type {TradeType} from '@/types';

const ds = new DataService();

export interface FUKlineSubscribe {
  type: 'kline-subscribe';
  symbol: string;
  resolution: number;
  tradeType: TradeType;
}

export interface FUKlineUnsubscribe {
  type: 'kline-unsubscribe';
  symbol: string;
  resolution: number;
  shouldNotUnsubscribe?: boolean;
  tradeType: TradeType;
}

const subscribeKline$ = uiMsg$.pipe(filter((o) => o.type === 'kline-subscribe'));
const unsubscribeKline$ = uiMsg$.pipe(filter((o) => o.type === 'kline-unsubscribe'));

export function subscribeKline() {
  wsOpened$.subscribe(() => ds.clear());

  subscribeKline$.subscribe((data: FUKlineSubscribe) => ds.subscribe(data.symbol, data.resolution, data.tradeType));
  unsubscribeKline$.subscribe((data: FUKlineUnsubscribe) =>
    ds.unsubscribe(data.symbol, data.resolution, data.shouldNotUnsubscribe)
  );
}
